import builder from '../builder';
import ACHeat from '../../streamline-icons/bold/ac-heat.svg';

export default builder('IconACHeatBold', ACHeat);
